import {
  Carousel,
  SecondOffer,
  DsIcon as Icon
} from '@itau-loans-www/components'

const carouselConfig = {
  slidesToShow: 2,
  slidesToScroll: 1,
  infinite: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        infinite: false,
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        infinite: false,
        slidesToShow: 1.25,
        slidesToScroll: 1
      }
    }
  ],
  arrows: true,
  nextArrow: <Icon name="seta-baixo" type="outlined" />,
  prevArrow: <Icon name="seta-baixo" type="outlined" />
}

const CardCarousel = ({ proposals }) => {
  return (
    <div className="card-carousel">
      <Carousel model="cards" config={carouselConfig}>
        {proposals.map((proposal, idx) => {
          return (
            <SecondOffer
              key={idx}
              className="--carousel"
              proposal={proposal}
              index={idx}
            />
          )
        })}
      </Carousel>
    </div>
  )
}

export default CardCarousel
